/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:20
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-30 10:08:22
 * @FilePath: \ioc_base\src\modules\broadcast\option\broadcastAudio.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const tableOption = function () {
  return {
    page: true,
    selection: false,
    menuLeft: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: "600px",
    emptyText: "暂无数据",
    add: "新增音频",
    menuWidth: 100,
    column: [{
        label: "音频名称",
        prop: "name",
        slot: true,
        search: true,
        clearable: true,
        addDisplay: true,
        searchDefault: [],
        type: "text",
        overHidden: true,
        span: 24,
        searchPlaceholder: "请输入音频名称",
        rules: [{
          required: true,
          message: "请输入音频名称",
          trigger: ['change', 'blur']
        }]

      },
      {
        label: "音频类型",
        prop: "type",
        addDisplay: false,
        viewDisplay: false,
        viewFormatter: (row, value) => {
          const statusMap = {
            1: "超速罚单",
            2: "车辆违规罚单"
          };
          return statusMap[value];
        }
      },
      {
        label: "文件大小",
        prop: "size",
        addDisplay: false,
        viewFormatter: (row, value) => {
          return value;
        }
      },
      {
        label: "上传人",
        prop: "creator",
        addDisplay: false,
        type: "text"
      },
      {
        label: "上传时间",
        prop: "createTime",
        addDisplay: false,
        type: "datetimerange",
        slot: true,
        search: true,
      },
      {
        label: "音频试听",
        prop: "fileCode",
        columnWidth: 330,
        addDisplay: false,
        span: 12,
        rules: [{
          required: true,
          message: "请上传音频文件",
          trigger: "blur"
        }]
      },
      {
        label: "音频文件",
        prop: "fileCode",
        hide: true,
        formslot: true,
        span: 24,
        rules: [{
          required: true,
          message: "请上传音频文件",
          trigger: 'blur'
        }, ],

      }
    ]
  };
};
export default tableOption;